import { Component } from '@angular/core';

@Component({
    templateUrl: './cemv-faq-page.component.html',
    styleUrls: ['./cemv-faq-page.component.scss']
})
export class CemvFaqPageComponent {}
